const NewRegistrations = ({ data }) => (

            <div class="card shadow-sm mb-3">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h2 class="h6 mb-0">New Registrations</h2>
                {/* <span class="badge bg-primary-subtle text-primary border badge-status">
                  Today
                </span> */}
              </div>
              <ul class="list-group list-group-flush">
                
                  {data.map((u, i) => (
                    <li class="list-group-item d-flex align-items-start">
                    <div key={i} class="flex-grow-1">
                      <div class="fw-semibold">{u.name}</div>
                      <small class="text-muted">{u.type}{(u.type === "Job Seeker") ? " - "+ u.experience : ""} - {u.current_location}</small>
                      {/* <span className="badge gray">{u.status}</span> */}
                    </div>
                     </li>
                  ))}
                  
                  
               
              </ul>
              <div class="card-footer text-end">
                <a href="/admin/candidates" class="small">View all users</a>
              </div>
            </div>
);

export default NewRegistrations;
